(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentTypeGroups', [ContentTypeGroupsDirective])
		.controller('ContentTypeGroupsController',
		[
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbContentTypeGroupsDataStore',
			'smbIconTypes',
			ContentTypeGroupsController
		]);

	var templateUrl = require('./contentTypeGroups.template');
	function ContentTypeGroupsDirective() {
		return {
			restrict: 'E',
			controller: ContentTypeGroupsController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}

	function ContentTypeGroupsController($state, gettextCatalog, pxProgressService, smbToolbarService, smbContentTypeGroupsDataStore, smbIconTypes) {
		smbToolbarService.set(gettextCatalog.getString('Document Groups'), 'content.home');

		var vm = this;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
		vm.contentTypeGroupsDataStore = smbContentTypeGroupsDataStore;

		pxProgressService.visible = true;
		smbContentTypeGroupsDataStore.loadFullAccessGroups()
			.then(function () {
				pxProgressService.visible = false;
			});
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroups/contentTypeGroups.js
// module id = 72
// module chunks = 1